import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const LoadingProgress: React.FC = () => (
  <div className="inset-0 absolute w-full h-full bg-white bg-opacity-40 flex justify-center items-center z-10">
    <CircularProgress
      size={38}
      style={{
        color: '#2D80E2',
      }}
    />
  </div>
);

export default LoadingProgress;
